import MovieDBapi from './MovieDBapi';

export const api = MovieDBapi();

export type { MovieDbApi, Genre, ApiMovie } from './MovieDBapi';
